// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'dinRoundOT', 'dinRoundOT Fallback', Objektiv, sans-serif"},"className":"__className_90c093","variable":"__variable_90c093"};